import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "toolbox-column" }
const _hoisted_2 = { class: "toolbox-menu__header__tool-buttons" }
const _hoisted_3 = { class: "toolbox-menu__content" }
const _hoisted_4 = {
  key: 0,
  class: "toolbox-menu"
}
const _hoisted_5 = {
  key: 1,
  class: "toolbox-menu"
}
const _hoisted_6 = {
  key: 2,
  class: "toolbox-menu"
}
const _hoisted_7 = {
  key: 3,
  class: "toolbox-menu"
}
const _hoisted_8 = { style: {"margin-bottom":"8px"} }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  class: "dotText",
  style: {"padding-left":"2px","text-align":"left"}
}
const _hoisted_12 = { class: "dotText" }
const _hoisted_13 = { class: "dotText" }
const _hoisted_14 = {
  key: 4,
  class: "toolbox-menu"
}
const _hoisted_15 = { class: "toolbox-temperature-container" }
const _hoisted_16 = { class: "toolbox-temperature-div" }
const _hoisted_17 = { class: "toolbox-temperature-div__small" }
const _hoisted_18 = { class: "toolbox-temperature-div__small" }
const _hoisted_19 = { class: "tempCircle-div" }

import { ref, computed, watch } from 'vue'
import _ from 'lodash'
import ButtonSquare from '../buttons/ButtonSquare/ButtonSquare.vue'
import DropDownSelection from '../../general/selectors/DropDownSelection.vue'
import RangeSliderSingle from '../selectors/Slider/RangeSliderSingle.vue'
import CustomRangeSlider from '../selectors/Slider/CustomRangeSlider.vue'
import ToolboxMenuItem from './ToolboxMenuItem.vue'
import { formatNumber } from '@/utils/math'
import {
  getSensorValueText,
  sensorTypeConfigs,
  SensorTypes,
  UNITS
} from '@/utils/format-sensor-values'
import { useStore } from 'vuex'
import { PLANVIEW_PREFIX, MAPVIEW_PREFIX } from '@/store/module-prefixes'
import {
  RESET_CURRENT_TOOL,
  SET_CURRENT_DATACOMPARISON,
  SET_CURRENT_DRAWING_TRANSPARENCY,
  SET_CURRENT_HEATMAP_INTENSITY,
  SET_CURRENT_MAP_DRAWING_TRANSPARENCY,
  SET_CURRENT_TOOL,
  SET_DATACOMPARISON_INTERVAL,
  SET_SELECTED_HEATMAP_DATE
} from '@/store/mutation-types'
import { useGeneralStore } from '@/pinia'
import { getColorForSensorValue } from '@/utils/format-sensor-values'
import { useI18n } from 'vue-i18n'

type Props = {
  expanded: boolean
}

type Emits = {
  (event: 'onToggleClick'): () => void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolboxMenu',
  props: {
    expanded: { type: Boolean, default: false }
  },
  emits: ["onToggleClick"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const { t } = useI18n()
const store = useStore()
const piniaStore = useGeneralStore()

const filteredDrawings = computed(() => piniaStore.filteredDrawings)
const selectedID = ref<string>()
const AREA_TYPES = [
  { name: 'BTA', value: 0, belongsToId: 'areaType00' },
  { name: 'BRA', value: 1, belongsToId: 'areaType01' },
  { name: 'LOA-h', value: 2, belongsToId: 'areaType02' },
  {
    name: t('general__data__area-efficiency-loa-h'),
    value: 3,
    id: 'areaType03'
  }
]

const crossIconSource = require('@/assets/icon-cross.png')
const dataComparisonIconSource = require('@/assets/icon-filter.svg')
const dataComparisonHigh = ref('')
const dataComparisonLow = ref('')
const formattedSensorText = ref('')
const measureAreaIconSource = require('@/assets/icon-measure-area.svg')
const measureLineIconSource = require('@/assets/icon-measure-line.svg')
const measurementTypeCleared = ref<string>()
const preventButtonInactive = ref(false)
const resetIconSource = require('@/assets/icon-reset--white.svg')
const toolsIconSource = require('@/assets/icon-tools.svg')
const selectedArea = ref(0)
const selectedAreaName = ref('BTA')
const sensorColor = ref<string>()

const selectedLevel = computed(() => store.state.selectedLevel)
const isMapviewShowing = computed<boolean>(() => store.getters.isMapviewShowing)
const isModelviewShowing = computed<boolean>(() => store.getters.isModelviewShowing)
const isMeasurementActive = computed<boolean>(() => store.getters.isMeasurementActive)
const isDataComparisonToolActive = computed<boolean>(() => store.getters.isDataComparisonToolActive)
const isPlanviewShowing = computed<boolean>(() => store.getters.isPlanviewShowing)
const currentDataComparison = computed<string>(() => store.state.currentDataComparison)
const currentMeasurement = computed<number>(() => store.state.currentMeasurement)
const currentTool = computed<string>(() => store.state.currentTool)
const dataComparisonInterval = computed<{ high: number; low: number }>(
  () => store.state.dataComparisonInterval
)
const currentSensordataType = computed<SensorTypes>(
  () => store.state[PLANVIEW_PREFIX].currentSensordataType
)
const currentDrawingTransparency = computed<number>(
  () => store.state[PLANVIEW_PREFIX].currentDrawingTransparency
)
const currentHeatmapIntensity = computed<number>(
  () => store.state[PLANVIEW_PREFIX].currentHeatmapIntensity
)
const heatmapDateArray = computed<{ timeStamps: Date[] } | null>(
  () => store.state[PLANVIEW_PREFIX].heatmapDateArray
)
const hoveredSensorData = computed(() => store.state[PLANVIEW_PREFIX].hoveredSensorData)
const isSensordataShowing = computed<boolean>(
  () => store.state[PLANVIEW_PREFIX].isSensordataShowing
)

const sensorTitle = computed<string>(() => {
  if (currentSensordataType.value === 'booking') return ''
  return `${t(`general__data__sensor-${currentSensordataType.value}`)}:`
})

const isToolboxMenuVisible = computed<boolean>(() => {
  if (
    Object.keys(sensorTypeConfigs).includes(currentSensordataType.value) &&
    hoveredSensorData.value != null
  )
    return true
  return false
})

const formattedMeasurement = computed<string>(() => {
  if (currentMeasurement.value !== null) {
    return formatNumber(currentMeasurement.value, 2)
  } else {
    return '0'
  }
})

const activeMeasurement = computed<string>(() => {
  if (currentTool.value === 'areameasurement') {
    return (
      t('general__data__area') +
      ': ' +
      formattedMeasurement.value +
      ' ' +
      t('general__data__unit-square-meter')
    )
  } else if (currentTool.value === 'linemeasurement') {
    return t('general__data__distance') + ': ' + formattedMeasurement.value + ' m'
  } else {
    return t('general__data__reset')
  }
})

const activeMeasurementIcon = computed<string>(() => {
  switch (currentTool.value) {
    case 'areameasurement':
      return measureAreaIconSource
    case 'linemeasurement':
      return measureLineIconSource
    case 'datacomparisontool':
      if (isMapviewShowing.value) {
        return dataComparisonIconSource
      } else {
        return toolsIconSource
      }
    default:
      return toolsIconSource
  }
})

const buttonImgSource = computed<string>(() => {
  return props.expanded ? crossIconSource : activeMeasurementIcon.value
})

watch(
  () => _.cloneDeep(filteredDrawings.value),
  (newDrawing, oldDrawings) => {
    if (newDrawing && oldDrawings?.filter((drawing) => drawing.visible).length === 1) {
      setCurrentDrawingTransparency({ currentDrawingTransparency: 0.8 })
      setCurrentDrawingTransparencyMap({ currentDrawingTransparency: 0.8 })
    }
  }
)

watch(currentDataComparison, (n, o) => {
  if (n === t('general__data__area-efficiency-loa-h'))
    setDataComparisonInterval({
      comparisonInterval: { low: 70, high: 100 }
    })
  if (o === t('general__data__area-efficiency-loa-h'))
    setDataComparisonInterval({
      comparisonInterval: { low: 3000, high: 7000 }
    })
})

watch(hoveredSensorData, () => {
  if (!hoveredSensorData.value) return
  const currentValue = hoveredSensorData.value.value
  formattedSensorText.value = getSensorValueText(
    currentValue,
    currentSensordataType.value,
    UNITS[currentSensordataType.value]
  )
  sensorColor.value =
    currentValue !== undefined
      ? getColorForSensorValue(currentSensordataType.value, currentValue)
      : undefined
})

function resetTool() {
  store.commit(RESET_CURRENT_TOOL)
}

function setCurrentDataComparison(payload: { currentDataComparison: string }) {
  store.commit(SET_CURRENT_DATACOMPARISON, payload)
}

function setTool(payload: { tool: string }) {
  store.commit(SET_CURRENT_TOOL, payload)
}

function setDataComparisonInterval(payload: { comparisonInterval: { high: number; low: number } }) {
  store.commit(SET_DATACOMPARISON_INTERVAL, payload)
}

function setCurrentDrawingTransparency(payload: { currentDrawingTransparency: number }) {
  store.commit(PLANVIEW_PREFIX + '/' + SET_CURRENT_DRAWING_TRANSPARENCY, payload)
}

function setCurrentHeatmapIntensity(payload: { intensity: number }) {
  store.commit(PLANVIEW_PREFIX + '/' + SET_CURRENT_HEATMAP_INTENSITY, payload)
}

function setSelectedHeatmapDate(payload: { date: Date }) {
  store.commit(PLANVIEW_PREFIX + '/' + SET_SELECTED_HEATMAP_DATE, payload)
}

function setCurrentDrawingTransparencyMap(payload: { currentDrawingTransparency: number }) {
  store.commit(MAPVIEW_PREFIX + '/' + SET_CURRENT_MAP_DRAWING_TRANSPARENCY, payload)
}

function setCursor(cursorType: string) {
  // @ts-ignore There's a bug in useMapbox that can initialize mapbox before the container is rendered, it is therefore not used here.
  store.map.getCanvas().style.cursor = cursorType
}

function changeHeatmapIntensity(value: number) {
  const intensity = value / 100
  setCurrentHeatmapIntensity({ intensity })
}

function clearMeasurement() {
  if (currentTool.value === 'linemeasurement') {
    preventButtonInactive.value = true
    measurementTypeCleared.value = 'linemeasurement'
    resetTool()
    setTimeout(() => {
      setTool({ tool: 'linemeasurement' })
    }, 500)
    setTimeout(() => {
      preventButtonInactive.value = false
      measurementTypeCleared.value = undefined
    }, 550)
  } else if (currentTool.value === 'areameasurement') {
    preventButtonInactive.value = true
    measurementTypeCleared.value = 'areameasurement'
    resetTool()
    setTimeout(() => {
      setTool({ tool: 'areameasurement' })
    }, 500)
    setTimeout(() => {
      preventButtonInactive.value = false
      measurementTypeCleared.value = undefined
    }, 550)
  }
}

function handleDataComparisonIntervalInput(e: KeyboardEvent) {
  if (e.keyCode === 13) {
    // Values changed when enter key is released
    let roundedLow: number = 0
    let roundedHigh: number = 0
    // @ts-ignore
    if (e.target.id === 'dataComparisonIntervalLow') {
      roundedLow = Math.round(parseFloat(dataComparisonLow.value.replace(',', '.')))
      roundedHigh = dataComparisonInterval.value.high
      // @ts-ignore
    } else if (e.target.id === 'dataComparisonIntervalHigh') {
      roundedLow = dataComparisonInterval.value.low
      roundedHigh = Math.round(parseFloat(dataComparisonHigh.value.replace(',', '.')))
    }
    if (isNaN(roundedLow) || isNaN(roundedHigh) || roundedLow < 0 || roundedHigh < 1) return
    if (
      currentDataComparison.value === t('general__data__area-efficiency-loa-h') &&
      (roundedLow > 99 || roundedHigh > 100)
    )
      return // Area efficiency is in percent and cannot exceed 100
    const comparisonInterval = { low: roundedLow, high: roundedHigh }
    if (roundedLow >= dataComparisonInterval.value.high) {
      comparisonInterval.high = roundedLow + 1 // Raise and add 1 to upper interval to prevent exceeding upper value
    }
    if (roundedHigh <= dataComparisonInterval.value.low) {
      comparisonInterval.low = roundedHigh - 1 // Lower and subtract 1 from lower interval to prevent overlapping interval min/max
    }
    setDataComparisonInterval({ comparisonInterval: comparisonInterval })
    dataComparisonLow.value = ''
    dataComparisonHigh.value = ''
  }
}

function onAreaMeasureButtonClick() {
  if (currentTool.value !== 'areameasurement') {
    resetTool()
  }
  if (!isMeasurementActive.value && currentTool.value !== 'areameasurement') {
    setTool({ tool: 'areameasurement' })
    emits('onToggleClick') // Closing menu on measurement selection
  } else {
    resetTool()
    setCursor('')
    // @ts-ignore
    emits('onToggleClick') // Closing menu if active measurement is selected (or "deselected")
  }
}

function onChangeHeatmapDate(index: number) {
  const date = heatmapDateArray.value?.timeStamps[index]
  if (date) setSelectedHeatmapDate({ date })
}

function onDataComparisonToolClick() {
  if (currentTool.value !== 'datacomparisontool') {
    resetTool()
  }
  if (!isDataComparisonToolActive.value && currentTool.value !== 'datacomparisontool') {
    setTool({ tool: 'datacomparisontool' })
    emits('onToggleClick') // Closing menu on measurement selection
  } else {
    resetTool()
    setCursor('')
    emits('onToggleClick') // Closing menu if active measurement is selected (or "deselected")
  }
}

function onLineMeasureButtonClick() {
  if (currentTool.value !== 'linemeasurement') {
    resetTool()
  }
  if (!isMeasurementActive.value && currentTool.value !== 'linemeasurement') {
    setTool({ tool: 'linemeasurement' })
    emits('onToggleClick') // Closing menu on measurement selection
  } else {
    resetTool()
    setCursor('')
    emits('onToggleClick') // Closing menu if active measurement is selected (or "deselected")
  }
}

function onToolButtonClick() {
  emits('onToggleClick')
  if (
    (isMeasurementActive.value && props.expanded) ||
    (isDataComparisonToolActive.value && props.expanded)
  ) {
    // Resetting tool if active when menu is closed
    resetTool()
    setCursor('')
  }
}

function rangeSliderValue(value: number) {
  const transparency = value / 100
  if (isMapviewShowing.value) {
    setCurrentDrawingTransparencyMap({ currentDrawingTransparency: transparency })
  } else {
    setCurrentDrawingTransparency({ currentDrawingTransparency: transparency })
  }
}

function selectArea(value: number, name: string, id: string) {
  selectedID.value = id
  selectedArea.value = value
  selectedAreaName.value = name
  setCurrentDataComparison({ currentDataComparison: name })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["toolbox-menu", { 'toolbox-menu--collapsed': !_ctx.expanded }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["toolbox-menu__header", { 'toolbox-menu__header--collapsed': !_ctx.expanded }])
      }, [
        _createVNode(ButtonSquare, {
          class: "toolbox-menu__header__toggle-button",
          imgSource: buttonImgSource.value,
          activeState: 
            (isMeasurementActive.value && !_ctx.expanded) ||
            (preventButtonInactive.value && !_ctx.expanded) ||
            (isDataComparisonToolActive.value && !_ctx.expanded && isMapviewShowing.value)
              ? 'active'
              : 'inactive'
          ,
          onClicked: onToolButtonClick
        }, null, 8, ["imgSource", "activeState"]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(ButtonSquare, {
            activeState: 
              currentTool.value === 'linemeasurement' || measurementTypeCleared.value === 'linemeasurement'
                ? 'active'
                : 'inactive'
            ,
            imgSource: _unref(measureLineIconSource),
            onClicked: onLineMeasureButtonClick
          }, null, 8, ["activeState", "imgSource"]),
          _createVNode(ButtonSquare, {
            activeState: 
              currentTool.value === 'areameasurement' || measurementTypeCleared.value === 'areameasurement'
                ? 'active'
                : 'inactive'
            ,
            imgSource: _unref(measureAreaIconSource),
            onClicked: onAreaMeasureButtonClick
          }, null, 8, ["activeState", "imgSource"]),
          _withDirectives(_createVNode(ButtonSquare, {
            activeState: currentTool.value === 'datacomparisontool' ? 'active' : 'inactive',
            imgSource: _unref(dataComparisonIconSource),
            onClicked: onDataComparisonToolClick
          }, null, 8, ["activeState", "imgSource"]), [
            [_vShow, isMapviewShowing.value]
          ])
        ], 512), [
          [_vShow, _ctx.expanded]
        ])
      ], 2),
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _ctx.expanded]
      ])
    ], 2),
    (
        (filteredDrawings.value.filter((drawing) => drawing.visible).length === 1 &&
          selectedLevel.value &&
          !isMapviewShowing.value) ||
        (filteredDrawings.value.filter((drawing) => drawing.visible).length === 1 &&
          !selectedLevel.value &&
          !isPlanviewShowing.value)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(ToolboxMenuItem, {
            id: "toolbox-menu-drawing-transparency-slider",
            class: "toolbox-menu-item-single",
            slimMobile: true,
            title: _ctx.$t('general__text__drawing-opacity')
          }, {
            default: _withCtx(() => [
              _createVNode(RangeSliderSingle, {
                class: "range-slider",
                startValue: currentDrawingTransparency.value * 100,
                onRangeSliderValue: rangeSliderValue
              }, null, 8, ["startValue"])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (
        isSensordataShowing.value &&
        currentSensordataType.value === 'presence' &&
        heatmapDateArray.value != null &&
        heatmapDateArray.value.timeStamps.length
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(ToolboxMenuItem, {
            class: "toolbox-menu-item-single",
            title: "Heatmap"
          }, {
            default: _withCtx(() => [
              _createVNode(CustomRangeSlider, {
                class: "range-slider",
                startValue: heatmapDateArray.value.timeStamps.length - 1,
                min: 0,
                max: heatmapDateArray.value.timeStamps.length - 1,
                displayValues: heatmapDateArray.value.timeStamps,
                subtitlePrefix: _ctx.$t('general__text__heatmap_time'),
                onRangeSliderValue: onChangeHeatmapDate
              }, null, 8, ["startValue", "max", "displayValues", "subtitlePrefix"])
            ]),
            _: 1
          }),
          _createVNode(ToolboxMenuItem, {
            class: "toolbox-menu-item-single__additional",
            title: _ctx.$t('general__text__heatmap_intensity')
          }, {
            default: _withCtx(() => [
              _createVNode(RangeSliderSingle, {
                class: "range-slider",
                startValue: currentHeatmapIntensity.value * 100,
                onRangeSliderValue: changeHeatmapIntensity
              }, null, 8, ["startValue"])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (isMeasurementActive.value || preventButtonInactive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(ToolboxMenuItem, {
            class: "toolbox-menu-item-single",
            subTitle: activeMeasurement.value,
            title: 
          isModelviewShowing.value
            ? _ctx.$t('general__text__measure-horizontal')
            : _ctx.$t('general__text__measure-horizontal-map')
        ,
            iconSource: _unref(resetIconSource),
            slimMobile: true,
            onOnIconClick: clearMeasurement
          }, null, 8, ["subTitle", "title", "iconSource"])
        ]))
      : _createCommentVNode("", true),
    (isDataComparisonToolActive.value && isMapviewShowing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(ToolboxMenuItem, {
            class: "toolbox-menu-item-single",
            title: _ctx.$t('general__text__data-visualization')
          }, {
            default: _withCtx(() => [
              _createVNode(DropDownSelection, {
                activeState: "active",
                cssClass: "dark",
                dropDownAbove: true,
                dropDownTitle: selectedAreaName.value,
                selectedID: selectedID.value,
                options: AREA_TYPES,
                onSelected: selectArea
              }, null, 8, ["dropDownTitle", "selectedID"]),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", {
                    id: "mid-small",
                    class: "dot-small"
                  }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('general__text__interval')) + ": " + _toDisplayString(dataComparisonInterval.value.low.toLocaleString('de')) + "–" + _toDisplayString(dataComparisonInterval.value.high.toLocaleString('de')) + " " + _toDisplayString(currentDataComparison.value === _ctx.$t('general__data__area-efficiency-loa-h')
                ? '%'
                : _ctx.$t('general__data__unit-square-meter')), 1)
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "dataComparisonIntervalLow",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataComparisonLow).value = $event)),
                class: "input-data-comparison",
                style: {"margin-right":"14px"},
                type: "text",
                placeholder: dataComparisonInterval.value.low.toLocaleString('de'),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (dataComparisonLow.value = '')),
                onKeyup: handleDataComparisonIntervalInput
              }, null, 40, _hoisted_9), [
                [_vModelText, dataComparisonLow.value]
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "dataComparisonIntervalHigh",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataComparisonHigh).value = $event)),
                class: "input-data-comparison",
                type: "text",
                placeholder: dataComparisonInterval.value.high.toLocaleString('de'),
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (dataComparisonHigh.value = '')),
                onKeyup: handleDataComparisonIntervalInput
              }, null, 40, _hoisted_10), [
                [_vModelText, dataComparisonHigh.value]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      id: "below",
                      class: "dot",
                      style: {"margin-left":"4px"}
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      id: "mid",
                      class: "dot"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      id: "above",
                      class: "dot"
                    })
                  ])
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('general__text__below')), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('general__text__within')), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('general__text__above')), 1)
                ])
              ])
            ]),
            _: 1,
            __: [5,6,7]
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (isToolboxMenuVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('general__text__room')) + ": " + _toDisplayString(hoveredSensorData.value.room), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("h4", null, _toDisplayString(sensorTitle.value) + " " + _toDisplayString(formattedSensorText.value), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (sensorColor.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({ 'background-color': sensorColor.value }),
                        class: "tempCircle"
                      }, null, 4))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})